import {
    BasicController,
    BasicLayoutManager,
    BasicModel,
    BasicSmartfoxConstants,
    BasicStandardOkDialogProperties, CommandController
} from "@goodgamestudios/core";
import {int} from "@goodgamestudios/math-utilities";
import {SFConstants} from "../../../constants/SFConstants";
import {ErrorCodes} from "../../../constants/shared/ErrorCodes";
import {Poker2Model} from "../../../model/Poker2Model";
import {Poker2WarningDialog} from "../../../view/dialogs/Poker2WarningDialog";
import {Poker2LayoutManager} from "../../../view/Poker2LayoutManager";
import {Poker2Command} from "../Poker2Command";

export class VCKCommand extends Poker2Command {
    protected get cmdId(): string {
        return "vck";
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            Poker2Model.sessionData.activeSpecialOffer = false;

            this.env.buildNumberServer = params[1];
            this.env.versionInformation.buildNumberServer = params[1];

            this.env.clientInstanceHash = (params.length > 1) ? int(params[2]) : -1;
            Poker2Model.localData.saveClientInstance(this.env.clientInstanceHash);

            this.layoutManager.showServerAndClientVersion();

            if (this.env.isSSO) {
                BasicModel.smartfoxClient.sendMessage(BasicSmartfoxConstants.C2S_LOGIN_SOCIAL, [this.env.pln , this.env.sig, BasicModel.smartfoxClient.connectionTime, BasicModel.smartfoxClient.roundTripTime, this.env.referrer, this.env.networkId]);
            }
            else {
                if (!BasicModel.smartfoxClient.userForcedDisconnect && Poker2Model.localData.readLoginDataUsername() != null && Poker2Model.localData.readLoginDataUsername() != "" && Poker2Model.localData.readLoginDataPass() != null && Poker2Model.localData.readLoginDataPass() != "") {
                    // Game-Autologin
                    // BasicModel.smartfoxClient.userForcedDisconnect = false;
                    // Poker2Model.userData.userName = Poker2Model.localData.readLoginDataUsername();
                    // Poker2Model.userData.loginPwd = Poker2Model.localData.readLoginDataPass();
                    // CommandController.instance.executeCommand(BasicController.COMMAND_LOGIN);
                }
                else {
                    this.layoutManager.onEndProgressbar();

                    if (Poker2Model.localData.cookieExists) {
                        this.layoutManager.state = 2;
                    }
                    else {
                        this.layoutManager.state = BasicLayoutManager.STATE_AVATAR_CREATION;
                    }
                }
            }
            return true;
        }

        if (error == 2) {
            this.layoutManager.showDialog("Poker2WarningDialog", new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_alert_bug"), Poker2Model.languageData.getTextById("errorcode_" + 98)));
            this.layoutManager.onEndProgressbar();
        }
        else
            this.layoutManager.showDialog("Poker2WarningDialog", new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_versioncheck_error"), Poker2Model.languageData.getTextById("generic_versioncheck_errorcode_" + error)));
        return false;
    }

    /**
     * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
     **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
